import { gql } from '@apollo/client';

import {
  UpdateInsightRecordingDocument,
  type UpdateInsightRecordingMutation,
  type UpdateInsightRecordingMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation UpdateInsightRecording($input: UpdateInsightRecordingInput!) {
      updateInsightRecordingWithResponse(input: $input) {
        id
      }
    }
  `;
}

export const UPDATE_INSIGHT_RECORDING = UpdateInsightRecordingDocument;
export type {
  UpdateInsightRecordingMutation,
  UpdateInsightRecordingMutationVariables,
};
